import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Hero from './Hero';
import ProofBar from './ProofBar';
import ComplianceSection from './ComplianceSection';
import TrustSection from './TrustSection';
import ProblemSection from './ProblemSection';
import FeaturesSection from './FeaturesSection';
import ModulesSection from './ModulesSection';
import GapSection from './GapSection';
import WhoItsForSection from './WhoItsForSection';
import ProofSection from './ProofSection';
import CTASection from './CTASection';
import Footer from './Footer';
import GetStartedModal from './GetStartedModal';

const SignupPage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setIsModalOpen(true);
    }, []);

    const handleSuccess = () => {
        setIsSubmitted(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        if (!isSubmitted) {
            navigate('/');
        }
    };

    return (
        <>
            <Header />
            <Hero />
            <ProofBar />
            <ComplianceSection />
            <TrustSection />
            <ProblemSection />
            <FeaturesSection />
            <ModulesSection />
            <GapSection />
            <WhoItsForSection />
            <ProofSection />
            <CTASection />
            <Footer />
            <GetStartedModal isOpen={isModalOpen} onClose={handleCloseModal} onSuccess={handleSuccess} />
        </>
    );
};

export default SignupPage;
